export default {
  install(Vue) {
    /**
     * 출력데이터를 날짜 포맷으로 리턴한다.
     * yyyymmdd => yyyy.mm.dd or dd.mm.yyyy
     * @param {String} date
     * @return {String} strDateFmt
     */
    Vue.prototype.$getGlobalDateFmt = function (date) {
      let strCalendarType = "B";
      let strDateFmt = "";

      if (date == undefined) return "";

      if (date.length == 6) {
        if (Vue.prototype.$config.CALENDAR_TYPE_A == strCalendarType) {
          strDateFmt += date.substring(0, 4);
          strDateFmt += Vue.prototype.$config.DATE_SEP;
          strDateFmt += date.substring(4);
        } else {
          strDateFmt += date.substring(4);
          strDateFmt += Vue.prototype.$config.DATE_SEP;
          strDateFmt += date.substring(0, 4);
        }
      } else if (date.length == 8) {
        if (Vue.prototype.$config.CALENDAR_TYPE_A == strCalendarType) {
          strDateFmt += date.substring(0, 4);
          strDateFmt += Vue.prototype.$config.DATE_SEP;
          strDateFmt += date.substring(4, 6);
          strDateFmt += Vue.prototype.$config.DATE_SEP;
          strDateFmt += date.substring(6);
        } else {
          strDateFmt += date.substring(6);
          strDateFmt += Vue.prototype.$config.DATE_SEP;
          strDateFmt += date.substring(4, 6);
          strDateFmt += Vue.prototype.$config.DATE_SEP;
          strDateFmt += date.substring(0, 4);
        }
      } else if (date.length == 20) {
        if (Vue.prototype.$config.CALENDAR_TYPE_A == strCalendarType) {
          strDateFmt += date.substring(0, 4);
          strDateFmt += Vue.prototype.$config.DATE_SEP;
          strDateFmt += date.substring(4, 6);
          strDateFmt += Vue.prototype.$config.DATE_SEP;
          strDateFmt += date.substring(6, 8);
        } else {
          strDateFmt += date.substring(6, 8);
          strDateFmt += Vue.prototype.$config.DATE_SEP;
          strDateFmt += date.substring(4, 6);
          strDateFmt += Vue.prototype.$config.DATE_SEP;
          strDateFmt += date.substring(0, 4);
        }
        strDateFmt += "  ";
        strDateFmt += date.substring(8, 10);
        strDateFmt += Vue.prototype.$config.TIME_SEP;
        strDateFmt += date.substring(10, 12);
        strDateFmt += Vue.prototype.$config.TIME_SEP;
        strDateFmt += date.substring(12, 14);
      } else {
        strDateFmt += date;
      }
      return strDateFmt.toString();
    };
    /**
     * 출력데이터를 날짜 포맷으로 리턴한다.
     * yyyymmdd => dd/mm/yyyy
     * @param {String} date
     * @return {String}
     */
    Vue.prototype.$getGlobalDateFmt2 = function (date) {
      let strDateFmt = "";
      strDateFmt += date.substring(6);
      strDateFmt += Vue.prototype.$config.DATE_SEP2;
      strDateFmt += date.substring(4, 6);
      strDateFmt += Vue.prototype.$config.DATE_SEP2;
      strDateFmt += date.substring(0, 4);
      return strDateFmt.toString();
    };
    /**
     * 출력데이터를 시간 포맷으로 리턴한다.
     * @param {String} time
     * @return {String} strTimeFmt
     */
    Vue.prototype.$getGlobalTimeFmt = function (time) {
      let strTimeFmt = "";

      if (time == undefined) return "";

      if (time.length == 6) {
        strTimeFmt += time.substring(0, 2);
        strTimeFmt += Vue.prototype.$config.TIME_SEP;
        strTimeFmt += time.substring(2, 4);
        strTimeFmt += Vue.prototype.$config.TIME_SEP;
        strTimeFmt += time.substring(4);
      } else if (time.length == 20) {
        strTimeFmt += time.substring(8, 10);
        strTimeFmt += Vue.prototype.$config.TIME_SEP;
        strTimeFmt += time.substring(10, 12);
        strTimeFmt += Vue.prototype.$config.TIME_SEP;
        strTimeFmt += time.substring(12, 14);
      } else {
        strTimeFmt += time;
      }
      return strTimeFmt.toString();
    };

    /**
     * 출력데이터를 날짜 년월일만 형식에 맞게 리턴한다.
     * 20211018140244955902 -> $getGlobalDateFmt('20211018') -> 18.10.2021
     * @param {String} date
     * @return {String} strDateFmt
     */
    Vue.prototype.$getGlobalDateYmd = function (date) {
      if (date == undefined) return "";
      if (date.length < 8) return date;

      let ymd = date.substr(0, 8);

      return ymd.length == 8 ? Vue.prototype.$getGlobalDateFmt(ymd) : ymd;
    };

    /**
     * Date 타입 날짜를 String YYYYMMDD 형식으로 변환
     * @param {Date} date
     * @return {String} date format YYYYMMDD
     */
    Vue.prototype.$getDateToString = function (date) {
      return date ? this.moment(date).format("YYYYMMDD") : this.moment().format("YYYYMMDD");
    };

    /**
     * String YYYYMMDD 형식의 날짜를 Date 타입으로 변환
     * @param {String} str
     * @return {Date}
     */
    Vue.prototype.$getStringToDate = function (str) {
      return str ? this.moment(str, "YYYYMMDD")._d : this.moment()._d;
    };

    /**
     * String dd/mm/yyyy 형식의 날짜를 YYYYMMDD 형식으로 변환
     * @param {String} str
     * @return {String} date format YYYYMMDD
     */
    Vue.prototype.$getGlobalDateToDate = function (str) {
      let strSplit = String(str).split("/");
      return strSplit[2] + strSplit[1] + strSplit[0];
    };

    /**
     * 월의 1일~말일 날짜 가져오기(이번달이면 toDate는 오늘)
     * @param {Number} year 년
     * @param {Number} month 월
     * @return {Object} {fromDate : "20210901", toDate :"20210930" }
     */
    Vue.prototype.$getMonth = function (year, month) {
      let toDate = "";
      let m = month < 10 ? _.padStart(month, 2, "0") : month;
      if (this.moment(`${year}-${m}`).format("YYYYMM") == this.moment().format("YYYYMM")) {
        toDate = this.moment().format("YYYYMMDD");
      } else {
        toDate = this.moment(`${year}-${m}`).endOf("month").format("YYYYMMDD");
      }
      return {
        fromDate: this.moment(`${year}-${m}`).startOf("month").format("YYYYMMDD"),
        toDate: toDate,
      };
    };

    /**
     * 숫자 천단위 콤마 format, 소수점 자릿수 적용
     * @param {Number || String} str 변환할 데이터
     * @param {Number} digit 기본값 2, 소수점 자릿수
     * @param {Boolean} isPointClass 기본값 false, 소수점 폰트 사이즈 분리
     * @return {String} #,###.##
     */
    Vue.prototype.$num = function (str, digit, isPointClass = false) {
      let returnVal = "";
      let strSplit = String(str).replace(/\,/gi, "").split(".");
      let dot = 0;
      if (!_.isUndefined(strSplit[1]) && strSplit[1].length > (_.isNil(digit) ? 2 : digit)) {
        dot = strSplit[1].substring(0, _.isNil(digit) ? 2 : digit);
      } else {
        dot = _.padEnd(_.isUndefined(strSplit[1]) ? "" : strSplit[1], _.isNil(digit) ? 2 : digit, "0");
      }
      let tmpAmtVal = strSplit[0];

      if (String(str).indexOf("-") > -1) {
        tmpAmtVal = tmpAmtVal.substr(1, tmpAmtVal.length - 1);
      }

      for (let i = tmpAmtVal.length - 1; i >= 0; i--) {
        returnVal = tmpAmtVal.charAt(i) + returnVal;
        if (i != 0 && i % 3 == tmpAmtVal.length % 3) returnVal = "," + returnVal;
      }

      returnVal = String(str).indexOf("-") > -1 ? "-" + returnVal : returnVal;

      if (digit == 0) {
        return returnVal;
      } else {
        if (isPointClass) {
          return `${returnVal}.<em>${dot}</em>`;
        } else {
          return `${returnVal}.${dot}`;
        }
      }
    };

    /**
     * 금액에서 천단위 콤마 삭제
     * @param {String} str 금액 ###,###.##
     * @return {String} ######.##
     */
    Vue.prototype.$removeComma = function (str) {
      if (str == null) return null;
      let amt = str + "";
      return amt.replace(/,/gi, "");
    };
  },
};
